import React from 'react';
import { getNodesFromRefs, observerEntriesToItems } from '../helpers';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';
function useIntersection({ items, itemsChanged, refs, options }) {
    const observer = React.useRef();
    const [visibleElementsWithSeparators, setVisibleElementsWithSeparators] = React.useState([]);
    const throttleTimer = React.useRef(+setTimeout(() => void 0, 0));
    const ioCb = React.useCallback((entries) => {
        items.set(observerEntriesToItems(entries, options));
        clearTimeout(throttleTimer.current);
        throttleTimer.current = +setTimeout(() => requestAnimationFrame(() => {
            setVisibleElementsWithSeparators((currentVisible) => {
                const newVisibleElements = items
                    .getVisible()
                    .map((el) => el[1].key);
                if (JSON.stringify(currentVisible) !==
                    JSON.stringify(newVisibleElements)) {
                    return newVisibleElements;
                }
                return currentVisible;
            });
        }), options.throttle);
    }, [items, options]);
    useIsomorphicLayoutEffect(() => {
        const elements = getNodesFromRefs(refs);
        const observerInstance = observer.current || new IntersectionObserver(ioCb, options);
        observer.current = observerInstance;
        elements.forEach((elem) => observerInstance.observe(elem));
        return () => {
            clearTimeout(throttleTimer.current);
            observerInstance.disconnect();
            observer.current = undefined;
        };
    }, [ioCb, itemsChanged, options, refs]);
    return visibleElementsWithSeparators;
}
export default useIntersection;
